
const { odata} = require("@azure/data-tables");

var commonUtility = require('../../domain/commonUtility');
var azureTableUtil = require('../../azureTables/azureTableUtil');
var azureTables = require('../../azureTables/azureTables');
var dateUtil = require('../../dateUtil/dateUtil');
var stringUtil = require('../../string/stringUtil');
var constants = require('../../domain/constants');



var allKey = "$ALL";
const dispatchStationId = "8d298b89-8de4-451c-8088-3d3f1d648c89";
var stateManager = require('../../state/stateManager');
var todaysSalesUpdatedDateTimeAction = require('../../state/actions/sales/todaysSalesUpdatedDateTimeAction');
var jobsServer = require('../../jobs/jobsServer');
var guidUtil = require('../../guid/guidUtil');
var loggerUtils = require('../../logger/utils');
var logger = require('../../logger/logger');
var salesChannel = require('../../messaging/sales/salesChannel');
var workerChannel = require('../../messaging/workerChannel');
var businessDateUtil = require('../../dateUtil/businessDateUtil');

export async function loadSaleStatus(businessDate)
{
    var franchisorId = commonUtility.getFranchisor().id;
    var propertyId = commonUtility.getProperty().id;

    var partitionKey = azureTableUtil.removeInvalidCharacters(`${franchisorId}::${propertyId}::${dateUtil.getYear(businessDate)}::${dateUtil.getMonth(businessDate)}::${dateUtil.getDate(businessDate)}`);

    let queryOption = {
        filter: odata`(PartitionKey eq ${partitionKey})`,
    };

    return azureTableUtil.loadEntities(azureTables.AzureTableSalesStatus, queryOption);
}


export function filterSalesStatus(salesStatus)
{
    return salesStatus.filter(statusLine => !stringUtil.isStringNullOrEmpty(statusLine.saleId) && 
                                            stringUtil.areStringSame(statusLine.saleItemId, allKey));
}

export function isStatusHavingSameKey (kdsStatusLine1, kdsStatusLine2)
{
    return stringUtil.areStringSame(kdsStatusLine1.type, kdsStatusLine2.type) &&
           stringUtil.areStringSame(kdsStatusLine1.saleId, kdsStatusLine2.saleId) &&
           stringUtil.areStringSame(kdsStatusLine1.saleItemId, kdsStatusLine2.saleItemId) &&
           stringUtil.areStringSame(kdsStatusLine1.kitchenStationId, kdsStatusLine2.kitchenStationId);
}

export function isLatestKdsStatusLine(newKdsStatusLine)
{
    var todaySalesKdsStatus = stateManager.getStore().getState().todaySalesKdsStatus;
    if (!todaySalesKdsStatus.has(newKdsStatusLine.saleId))
        return true;
    
    var existingKdsStatusLines = todaySalesKdsStatus.get(newKdsStatusLine.saleId);

    var existingKdsStatusLine = existingKdsStatusLines.find(existingLine => isStatusHavingSameKey(existingLine, newKdsStatusLine));
    if (existingKdsStatusLine == null)
        return true;

    return newKdsStatusLine.lastUpdatedTime >  existingKdsStatusLine.lastUpdatedTime;
}

function getStatusLines (saleId)
{
    var todaySalesKdsStatus = stateManager.getStore().getState().todaySalesKdsStatus;

    if (!todaySalesKdsStatus.has(saleId))
        return [];

    return todaySalesKdsStatus.get(saleId);
}



function addNewStatusLineIfLatest (newStatusLine)
{
    if (!isLatestKdsStatusLine(newStatusLine))
        return false;
    
    let existingStatusLines = getStatusLines(newStatusLine.saleId);
    existingStatusLines = existingStatusLines.filter(statusLine => !isStatusHavingSameKey(statusLine, newStatusLine));
    existingStatusLines.push(newStatusLine);
    
    stateManager.getStore().getState().todaySalesKdsStatus.set(newStatusLine.saleId, existingStatusLines);
    return true;
}

export function addNewStatusLinesIfLatest(newStatusLines)
{
    newStatusLines = filterSalesStatus(newStatusLines);
    
    let updatedSaleIds = [];
    newStatusLines.forEach (newStatusLine =>
    {
        if (addNewStatusLineIfLatest(newStatusLine))
        {
            updatedSaleIds.push(newStatusLine.saleId);
        }
    });

    return updatedSaleIds;
}

export function isSaleCompletedByAnyFinalStation(saleId)
{
    let statusLines = getStatusLines(saleId);
    
    return statusLines.some((line) => line.type == constants.KdsStatusTypes.status &&
                                      line.saleItemId == allKey &&
                                      line.isFinalStation &&
                                      line.value == constants.KdsStatus.completed    
                           );
}

export function isSaleCompletedByDispatchStation(saleId)
{
    let statusLines = getStatusLines(saleId);
    return statusLines.some((line) => line.type == constants.KdsStatusTypes.status &&
                                      line.saleItemId == allKey &&
                                      line.kitchenStationId == dispatchStationId &&
                                      line.value == constants.KdsStatus.completed    
                           );
}

export function isSalePendingDueToTime(sale)
{
    var activationThresholdTimeInMin = getOrderActivationThresholdInMinutes(sale);
    var activationDateTime = dateUtil.addMinutes(dateUtil.getNow(), activationThresholdTimeInMin);
    return dateUtil.isAfter(sale.dueDateTime, activationDateTime);
}


export function getDueDateTimeFromStatusLines(saleId)
{
    let statusLines = getStatusLines(saleId);
    let dueDateTimeStatusLine = statusLines.find((line) =>  line.type == constants.KdsStatusTypes.dueDateTime &&
                                                            line.saleItemId == allKey &&
                                                            line.kitchenStationId == allKey    
                                                );
    if (dueDateTimeStatusLine == null)
        return null;

    return dueDateTimeStatusLine.value;
}

export function getActivationDateTimeFromStatusLines(saleId)
{
    let statusLines = getStatusLines(saleId);
    let activationDateTimeStatusLine = statusLines.find((line) =>  line.type == constants.KdsStatusTypes.activationDateTime &&
                                                                    line.saleItemId == allKey &&
                                                                    line.kitchenStationId == allKey    
                                                );
    if (activationDateTimeStatusLine == null)
        return null;

    return activationDateTimeStatusLine.value;
}


export function getOrderActivationThresholdInMinutes(sale)
{
    var storefront = commonUtility.getPropertyStorefronts().find (storefront => storefront.id == sale.storefrontId);

    if(storefront != null && storefront.operatingConfiguration && 
       !stringUtil.isStringNullOrEmpty(storefront.operatingConfiguration.orderActivationThresholdInMinutes))
        return storefront.operatingConfiguration.orderActivationThresholdInMinutes;

    return constants.activationThresholdInMinutes;
}

export function getKitchenStationProfiles()
{
    let kitchenStationProfiles = stateManager.getStore().getState().lookupData.kitchenStationProfiles;
    if (kitchenStationProfiles == null) kitchenStationProfiles = [];
    return kitchenStationProfiles.filter(k => k.stationType == constants.kitchenStationTypes.stationTypeMonitor);
}

export function getFinalStationId()
{
    let kitchenStationProfiles = getKitchenStationProfiles();
    let finalStation = kitchenStationProfiles.find(k => k.isFinalStation);
    if (finalStation == null) return "";
    return finalStation.id;
}

export function markSaleStatusAsCompletedByDispatchStation (sale)
{
    const combinesStatusLines = [];
    if (!isSaleCompletedByAnyFinalStation(sale.id))
    {
        let finalStationId = getFinalStationId();
        if (!stringUtil.isStringNullOrEmpty(finalStationId))
        {
            const statusLines = createSaleStatusCompletedStatusLines(sale, finalStationId, true);
            combinesStatusLines.push(...statusLines);
        }
    }

    const statusLines = createSaleStatusCompletedStatusLines(sale, dispatchStationId, false);
    combinesStatusLines.push(...statusLines)

    addUpdateStatusLine(combinesStatusLines);
}

export function markSaleStatusAsCompletedByFinalStation (sale)
{
    let finalStationId = getFinalStationId();
    if (stringUtil.isStringNullOrEmpty(finalStationId)) return;

    let statusLines = createSaleStatusCompletedStatusLines(sale, finalStationId, true);

    addUpdateStatusLine(statusLines);
}

function createSaleStatusCompletedStatusLines(sale, stationId, isFinalStation)
{
    let statusLines = [];

    let newStatusLine = {};
    newStatusLine.type = constants.KdsStatusTypes.status;
    newStatusLine.saleId = sale.id;
    newStatusLine.saleItemId = allKey;
    newStatusLine.kitchenStationId = stationId;
    newStatusLine.value = constants.KdsStatus.completed;
    newStatusLine.isFinalStation = isFinalStation;
    newStatusLine.lastUpdatedTime = dateUtil.getNow();
    statusLines.push(newStatusLine);

    sale.saleItems.forEach(saleItem =>
    {
        for (var index = 0; index < saleItem.quantity; index++)
        {
            let newStatusLine = {};
            newStatusLine.type = constants.KdsStatusTypes.status;
            newStatusLine.saleId = sale.id;
            newStatusLine.saleItemId = `${saleItem.id}.${index}`;
            newStatusLine.kitchenStationId = stationId;
            newStatusLine.value = constants.KdsStatus.completed;
            newStatusLine.isFinalStation = isFinalStation;
            newStatusLine.lastUpdatedTime = dateUtil.getNow();
            statusLines.push(newStatusLine);
        }
    });

    return statusLines;
}

export function updateDueTime(saleId, dueDateTime)
{
    var newStatusLine = {};
    newStatusLine.type = constants.KdsStatusTypes.dueDateTime;
    newStatusLine.saleId = saleId;
    newStatusLine.saleItemId = allKey;
    newStatusLine.kitchenStationId = allKey;
    newStatusLine.value = dueDateTime;
    newStatusLine.lastUpdatedTime = dateUtil.getNow();

    addUpdateStatusLine([newStatusLine])
}

export function updateActivationTime(saleId, activationDateTime)
{
    var newStatusLine = {};
    newStatusLine.type = constants.KdsStatusTypes.activationDateTime;
    newStatusLine.saleId = saleId;
    newStatusLine.saleItemId = allKey;
    newStatusLine.kitchenStationId = allKey;
    newStatusLine.value = activationDateTime;
    newStatusLine.lastUpdatedTime = dateUtil.getNow();

    addUpdateStatusLine([newStatusLine])
}

function addUpdateStatusLine(newStatusLines)
{
    let saleId = newStatusLines[0].saleId;
    let existingStatusLines = getStatusLines(saleId);

    newStatusLines.forEach(newStatusLine =>
    {
        existingStatusLines = existingStatusLines.filter(statusLine => !isStatusHavingSameKey(statusLine, newStatusLine));
        existingStatusLines.push(newStatusLine);    
    })
    

    stateManager.getStore().getState().todaySalesKdsStatus.set(saleId, existingStatusLines);
    publishStatusLines(newStatusLines);
    stateManager.getStore().dispatch(todaysSalesUpdatedDateTimeAction.createAction());
}



function publishStatusLines(statusLines)
{
    var orgContext = {
        franchisorId: commonUtility.getFranchisor().id,
        franchiseeId: commonUtility.getFranchisee().id,
        propertyId: commonUtility.getProperty().id
        }

    let messagePayload = {};
    messagePayload.type = "sale.status";
    messagePayload.statusLines = statusLines
    messagePayload.tracingContext = loggerUtils.createTracingContext("sales.channel", "sale.status.publishing");
    logger.info("Sending a sale status message to sale channel");
    salesChannel.publishMessage(messagePayload);

    messagePayload = {};
    messagePayload.type = "sale.station.status";
    messagePayload.statusLines = statusLines
    messagePayload.orgContext = orgContext;
    logger.info("Sending a sale status message to worker channel");
    workerChannel.publishMessage(messagePayload);

    jobsServer.addJob(guidUtil.generateGuid(), "Publishing KDS Status To Channel", 
    async ()=>
    {
        var todayDate = businessDateUtil.getTodayBusinessDate();
        var franchisorId = commonUtility.getFranchisor().id;
        var propertyId = commonUtility.getProperty().id;

        statusLines.forEach(statusLine =>
        {
            statusLine.partitionKey = azureTableUtil.removeInvalidCharacters(`${franchisorId}::${propertyId}::${dateUtil.getYear(todayDate)}::${dateUtil.getMonth(todayDate)}::${dateUtil.getDate(todayDate)}`);
            const rowKey = getStatusRowKey(statusLine);
            statusLine.rowKey = azureTableUtil.removeInvalidCharacters(rowKey);
        })

        azureTableUtil.upsertEntities(azureTables.AzureTableSalesStatus, statusLines);
        logger.info("Sale status message published successfully");
        return Promise.resolve(true);
    }, true)
}

function getStatusRowKey (kdsStatusLine)
{
    return `${kdsStatusLine.type}::${kdsStatusLine.saleId}::${kdsStatusLine.saleItemId || allKey}::${kdsStatusLine.kitchenStationId}`
}